import type { ContratProADTO } from '@/features/api/extranet/dto/Demande/PROA'

export * from '@/features/domaine/regles-akto/shared/preconditions'

export const preNotNirTemporaire = (_value: any, _parent: any, modele: ContratProADTO) =>
  modele.salarie?.nirTemporaire !== true
export const preNirTemporaire = (_value: any, _parent: any, modele: ContratProADTO) =>
  modele.salarie?.nirTemporaire === true
